import { Box, styled } from '@mui/material';

export const StyledScrollBox = styled(Box)(({ theme }) => ({
  overflowX: 'auto',
  maxWidth: '100%',
  '&::-webkit-scrollbar': {
    height: '8px',
    width: '8px',
  },
  '&::-webkit-scrollbar-track': {
    backgroundColor: 'transparent',
    borderRadius: '4px',
  },
  '&::-webkit-scrollbar-thumb': {
    background: `${theme.scrollbar?.thumb}`,
    borderRadius: '4px',
  },
  '&::-webkit-scrollbar-thumb:hover': {
    background: `${theme.scrollbar?.thumbHover}`,
  },
}));
